/**
 * @generated SignedSource<<4d596a00cb2778906089b14b8d250f63>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreatePhoneVerificationInput = {
  phoneNumber: string;
};
export type useCreatePhoneVerificationNotificationsMutation$variables = {
  input: CreatePhoneVerificationInput;
};
export type useCreatePhoneVerificationNotificationsMutation$data = {
  readonly responsePayload: {
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string | null | undefined;
    } | null | undefined>;
    readonly success: boolean;
  } | null | undefined;
};
export type useCreatePhoneVerificationNotificationsMutation = {
  response: useCreatePhoneVerificationNotificationsMutation$data;
  variables: useCreatePhoneVerificationNotificationsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCreatePhoneVerificationNotificationsMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "CreatePhoneVerificationPayload",
        "kind": "LinkedField",
        "name": "createPhoneVerification",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCreatePhoneVerificationNotificationsMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "CreatePhoneVerificationPayload",
        "kind": "LinkedField",
        "name": "createPhoneVerification",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "de6998564d82147a96416139290ea786",
    "id": null,
    "metadata": {},
    "name": "useCreatePhoneVerificationNotificationsMutation",
    "operationKind": "mutation",
    "text": "mutation useCreatePhoneVerificationNotificationsMutation(\n  $input: CreatePhoneVerificationInput!\n) {\n  responsePayload: createPhoneVerification(input: $input) {\n    success\n    errors {\n      __typename\n      field\n      code\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ce86efc6d67fd22c46e8ae41bd2f7341";

export default node;
